import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {Trigger} from '@models/adminstration/machine/trigger/trigger';
import {AddTriggerQueryRequest} from '@models/adminstration/machine/trigger/trigger-query/add-trigger-query-request';
import {
  UpdateTriggerQueryRequest
} from '@models/adminstration/machine/trigger/trigger-query/update-trigger-query-request';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';

@Injectable({
  providedIn: 'root'
})
export class TriggerQueryService {

  private MACHINE_TRIGGER_QUERY_LIST_URL_SUFFIX = '/api/web/admin/machine/:id/triggerQuery';
  private MACHINE_TRIGGER_QUERY_DELETE_URL_SUFFIX = '/api/web/admin/machine/:id/triggerQuery?queryId=:qId';
  private MACHINE_TRIGGER_QUERY_ADD_URL_SUFFIX = '/api/web/admin/machine/:id/triggerQuery';
  private MACHINE_TRIGGER_QUERY_UPDATE_URL_SUFFIX = '/api/web/admin/machine/:id/triggerQuery';
  private MACHINE_TRIGGER_QUERY_LIST_PUBSUB_TOPICS = '/api/web/admin/pubsub/topics';

  private readonly BASE_URL: string;

  constructor(
      private http: HttpClient,
      private apiLocation: ApiLocationService
  ) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public triggerQuery(machineId: number): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_TRIGGER_QUERY_LIST_URL_SUFFIX;
    url = url.replace(':id', String(machineId));
    return this.http.get<Trigger[]>(url, HTTPS_REQUEST_OPTIONS).pipe(shareReplay({
      bufferSize: 1,
      refCount: true
    }));
  }

  public delete(machineId: number, triggerQueryId: number): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_TRIGGER_QUERY_DELETE_URL_SUFFIX;
    url = url.replace(':id', String(machineId)).replace(':qId', String(triggerQueryId));
    return this.http.delete(url, HTTPS_REQUEST_OPTIONS);
  }

  public addTrigger(parentId: number, request: AddTriggerQueryRequest): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_TRIGGER_QUERY_ADD_URL_SUFFIX;
    url = url.replace(':id', String(parentId));
    return this.http.post<Trigger>(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public updateTrigger(parentId: number, request: UpdateTriggerQueryRequest): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_TRIGGER_QUERY_UPDATE_URL_SUFFIX;
    url = url.replace(':id', String(parentId));
    return this.http.post<Trigger>(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public getPubSubTopics(): Observable<any> {
    const url: string = this.BASE_URL + this.MACHINE_TRIGGER_QUERY_LIST_PUBSUB_TOPICS;
    return this.http.get<string[]>(url, HTTPS_REQUEST_OPTIONS).pipe(shareReplay({
      bufferSize: 1,
      refCount: true
    }));
  }

}
